import * as semver from "semver";

export function isValidVersion(input: string, strict: boolean = false): boolean {
    if (strict) {
        throw new Error("NotImplementedError");
    }
    return /^v?(\d)+\.(\d)+\.(\d)+$/i.test(input) || /^pre\:/.test(input);
}

export function isValidSemVerVersionRange(input: string, strict: boolean = false): boolean {
    if (strict) {
        throw new Error("NotImplementedError");
    }
    return /^pre\:/.test(input) || semver.validRange(input) != undefined;
}

export function parseCandyVersionSpec(input: string): CandyVersionSpec {
    if (/^pre\:/.test(input)) {
        return {
            type: "pre",
            preId: input.replace(/^pre:/i, ""),
        };
    } else {
        return {
            type: "version",
            version: input,
        };
    }
}

export function candyVersionSpecToString(input: CandyVersionSpec): string {
    return input.type === "version" ? input.version : `pre:${input.preId}`;
}

export type CandyVersionSpec =
    | {
          type: "pre";
          preId: string;
      }
    | {
          type: "version";
          version: string;
      };
